const getSettings = async () => {
  return fetch('/app.settings.json').then((response) => response.json());
};
const debugSetting = await getSettings();
export const debugMode = () => {
  if (debugSetting.DeveloperMode) {
    console.log.bind(globalThis.console);
  } else {
    console.log = () => null;
  }
};
